import { useMemo } from 'react';
import { usePortalPlatformData } from './usePortalPlatformData';
export function isNodeVisible(node) {
  const hasLabel = typeof node.label === 'string' && node.label.length > 0;
  const isLive = node.live !== false;
  const isPublished = node.isPublished !== false;
  return hasLabel && isLive && isPublished;
}
export function useNavigationMenu() {
  var _portalPlatformData$c;
  const portalPlatformData = usePortalPlatformData();
  return useMemo(() => {
    var _menuData$children$fi, _menuData$children;
    // @ts-expect-error Menu Data is not typed
    const menuData = portalPlatformData.context.menuData;
    return (_menuData$children$fi = menuData === null || menuData === void 0 || (_menuData$children = menuData.children) === null || _menuData$children === void 0 ? void 0 : _menuData$children.filter(isNodeVisible)) !== null && _menuData$children$fi !== void 0 ? _menuData$children$fi : [];
    // @ts-expect-error Menu Data is not typed
  }, [(_portalPlatformData$c = portalPlatformData.context) === null || _portalPlatformData$c === void 0 ? void 0 : _portalPlatformData$c.menuData]);
}